import type { MatrixRuntimeModule } from './contracts';

let modulePromise: Promise<MatrixRuntimeModule> | null = null;

export const loadMatrixRuntime = () => {
  modulePromise ??= import('./MatrixRuntime');
  return modulePromise;
};
